export const personOptions = [
  { label: "Pessoa Física", value: "Pessoa Física" },
  { label: "Pessoa Jurídica", value: "Pessoa Jurídica" },
];